import { render, staticRenderFns } from "./widget_add.vue?vue&type=template&id=3de44624&scoped=true&"
import script from "./widget_add.vue?vue&type=script&lang=js&"
export * from "./widget_add.vue?vue&type=script&lang=js&"
import style0 from "./widget_add.vue?vue&type=style&index=0&id=3de44624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de44624",
  null
  
)

export default component.exports